/** @file usePlayheadClip: the playhead clip's name and document, selected as two stable store slices. */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { useEditor } from '../../state/useEditor';

/** `{ name, clip }` of the playhead clip, or null when none is set or the document lacks it. */
export function usePlayheadClip(): { name: string; clip: Clip } | null {
  const name = useEditor((s) => s.playhead.clip);
  const clip = useEditor((s) => (name === null ? undefined : s.puppet.doc?.clips[name]));
  return name === null || clip === undefined ? null : { name, clip };
}
